module.exports = __webpack_public_path__ + "static/convertcalculator-1-bb19fa01701ac62f097787c4f914c11b.png";